var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import id from "@irati/utils/id";
import Wrapper from "../Wrapper";
import SecondaryDetailsItem from "../Item";
var ManualCredit = /** @class */ (function (_super) {
    __extends(ManualCredit, _super);
    function ManualCredit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ManualCredit.prototype.render = function () {
        var _a = this.props, className = _a.className, data = _a.data, intl = _a.intl;
        var currency = data.currency, transactionAmount = data.transactionAmount;
        var idNamespace = id("secondary-details-manual-credit", this.props);
        var text = (currency && transactionAmount) ? React.createElement(FormattedMessage, { id: "wallet.secondaryDetails.manualCredit.transactionDescription", values: {
                amount: intl.formatNumber(transactionAmount, { style: "currency", currency: currency })
            } }) : null;
        return (React.createElement(Wrapper, { className: className, id: idNamespace }, text && React.createElement(SecondaryDetailsItem, { isFirstItem: true, text: text })));
    };
    return ManualCredit;
}(PureComponent));
export default injectIntl(ManualCredit);
